import { render, staticRenderFns } from "./page-register.vue?vue&type=template&id=b995526a&"
import script from "./page-register.vue?vue&type=script&lang=js&"
export * from "./page-register.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports